globalThis.backoffice = globalThis.backoffice || {};

backoffice.EmailModelPreviewer = (function()
{
  function EmailModelPreviewer() {}

  EmailModelPreviewer.preview = function($el){
    var params = {},
        $form = $el.closest('form'),
        ajax_url = $el.data('ajax-url');

    if($form.length) {
      var subject_content = $form.find('input.subject-content').val(),
          ckeditor_instance = $form.find('textarea.body-content').attr('id');
      if(typeof(CKEDITOR) != 'undefined' && CKEDITOR.instances[ckeditor_instance]) {
        var body_content = CKEDITOR.instances[ckeditor_instance].getData();
      }

      if(subject_content && body_content) {
        params = {
          subject_content: subject_content,
          body_content: body_content
        }
      }
    }

    $.get(ajax_url, params, function(data) {
      var subject_content = data.subject_content,
          body_content = data.body_content,
          $modal = $(data.modal);

      if(subject_content && body_content && $modal.length) {
        $modal.appendTo($('body'));
        $modal.find('.modal-title').html(subject_content);

        var $iframe = $('<iframe/>', {
          id: 'email-model',
          frameborder: 'non',
          width: '100%'
        }).appendTo($modal.find('.modal-body'));

        var iframeDocument = $iframe[0].contentDocument || $iframe[0].contentWindow.document;
        iframeDocument.write(body_content);
        iframeDocument.close();

        $iframe.load(function() {
          setTimeout(function(){
            $iframe.css('height', $iframe.contents().height());
            $('#loader-wrapper').hide();
          }, 300)
        });

        $modal.modal('show');
        $modal.on('hidden.bs.modal', function(){
          $modal.remove();
        });
      }
    });

  }

  return EmailModelPreviewer;
})();
